import { useEffect, useRef, useState } from "react";
import { Navbar, Nav, Button, Badge } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import Layout from "../Website/Layout";
import Logo from "../../Imge/LogoNohe.png";
import Logout from "../../Pages/Auth/Logout";
import useAuth from "../../Pages/hooks/useAuth";
import { FaWallet, FaMessage } from "react-icons/fa6";
import Anonymath from "../../Imge/anonymath.png";
import { resolveMediaUrl } from "../../utils/mediaUrl";
import HeaderWithMessage from "./messageCard";
import useAxiosPrivate from "../../Pages/hooks/useAxiosPrivate";
import { baseURL, RETURNRESPONSE } from "../../API/API";
import ThemeToggle from "./ThemeToggle";

export default function Header() {
  const [expanded, setExpanded] = useState(false);
  const { auth } = useAuth();
  const [showMessageCard, setShowMessageCard] = useState(false);
  const [displayCredit, setDisplayCredit] = useState(() => Number(auth?.user?.credit ?? 0));
  const [creditColor, setCreditColor] = useState("inherit");
  const prevCreditRef = useRef(Number(auth?.user?.credit ?? 0));
  const [messageCount, setMessageCount] = useState(0);
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const isStaff = auth?.user?.is_staff;
  const credit = Number(auth?.user?.credit ?? 0);
  const profileImageSrc =
    resolveMediaUrl(auth?.user?.profileImage) ||
    resolveMediaUrl(auth?.user?.profile_image) ||
    Anonymath;
  const nameUser = auth?.user?.username;

  // تحديث عدد الرسائل كل 30 ثانية
  useEffect(() => {
    const updateMessageCount = async () => {
      if (auth.accessToken) {
        try {
          const res = await axiosPrivate.get(`${baseURL}/${RETURNRESPONSE}`);
          const messages = Array.isArray(res.data.data) ? res.data.data : [];
          setMessageCount(messages.length);
        } catch (err) {
          console.error("Error fetching message count:", err);
        }
      }
    };

    // جلب العدد عند التحميل
    updateMessageCount();

    // إعادة الجلب كل 30 ثانية
    const interval = setInterval(updateMessageCount, 30000);
    return () => clearInterval(interval);
  }, [auth.accessToken, axiosPrivate]);

  useEffect(() => {
    const previous = Number(prevCreditRef.current ?? 0);
    if (credit === previous) {
      setDisplayCredit(credit);
      return;
    }

    const diff = credit - previous;
    const duration = 1000;
    let startTimestamp = null;

    setCreditColor(diff > 0 ? "#28a745" : diff < 0 ? "#dc3545" : "inherit");

    const animate = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const elapsed = timestamp - startTimestamp;
      const progress = Math.min(elapsed / duration, 1);
      const nextValue = Math.round(previous + diff * progress);
      setDisplayCredit(nextValue);
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        prevCreditRef.current = credit;
        setTimeout(() => {
          setCreditColor("inherit");
        }, 2000);
      }
    };

    requestAnimationFrame(animate);
  }, [credit]);

  return (
    <>
      <Navbar
      expand="lg"
      className="custom-navbar"
      dir="rtl"
      expanded={expanded}
      onToggle={(value) => setExpanded(value)}
    >
      <Layout fluid className="px-0 d-flex align-items-center justify-content-between header-container w-100">
        <div className="brand-section d-flex align-items-center gap-3">
          <Navbar.Brand as={NavLink} to="/" className="m-0 d-flex align-items-center">
            <img
              src={Logo}
              alt="Logo"
              className="img-fluid align-top brand-logo"
              style={{ width: "60px", height: "60px", borderRadius: "50%", objectFit: "cover" }}
            />
            <span className="platform-name gold ms-2 fw-bold d-none d-sm-inline-block" style={{ fontSize: "18px" }}>نوح اكاديمي</span>
          </Navbar.Brand>
          <ThemeToggle />
        </div>

        <Navbar.Toggle aria-controls="main-navbar" />

        <Navbar.Collapse
          id="main-navbar"
          className={`${expanded ? "custom-collapse" : ""}`}
        >
          <Nav className="mx-auto gap-3 align-items-center nav-links">
            <Nav.Link as={NavLink} to="/" end className="sections nav-item-link">
              الرئيسية
            </Nav.Link>
            <Nav.Link as={NavLink} to="/aboutus" className="sections nav-item-link">
              من نحن
            </Nav.Link>
            {auth.accessToken && (
              <>
                <Nav.Link as={NavLink} to="/courses/general" className="sections nav-item-link">
                  الدورات
                </Nav.Link>
                <Nav.Link as={NavLink} to="/payment" className="sections nav-item-link">
                  طلبات الدفع
                </Nav.Link>
                {isStaff && (
                  <Nav.Link
                    as={NavLink}
                    to="/DashboardLayout"
                    className="sections nav-item-link"
                  >
                    لوحه تحكم
                  </Nav.Link>
                )}
              </>
            )}
          </Nav>

          <div className="d-flex align-items-center gap-3 collapse-actions-wrapper">
            {auth.accessToken && (
              <>
                <div style={{ position: "relative" }}>
                  <Button
                    variant="link"
                    className="text-decoration-none p-0"
                    onClick={() => setShowMessageCard(true)}
                    style={{ fontSize: "1.5rem", color: "var(--brand-200)", transition: "all 0.3s ease" }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.color = "var(--brand-300)";
                      e.currentTarget.style.transform = "scale(1.1)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.color = "var(--brand-200)";
                      e.currentTarget.style.transform = "scale(1)";
                    }}
                  >
                    <FaMessage className="message-icon-heder" />
                  </Button>
                  {messageCount > 0 && (
                    <Badge 
                      bg="danger" 
                      className="position-absolute" 
                      style={{
                        top: "-8px",
                        right: "-8px",
                        fontSize: "0.7rem",
                        borderRadius: "50%",
                        padding: "4px 6px",
                      }}
                    >
                      {messageCount}
                    </Badge>
                  )}
                </div>
                {!isStaff && (
                  <div className="d-flex align-items-center gap-2 wallet-block">
                    <div className="wallet-credit" style={{ color: creditColor }}>
                      {displayCredit} جنيه
                    </div>
                    <div
                      className="numberofuser"
                      style={{ width: 40, height: 40, display: "grid", placeItems: "center" }}
                    >
                      <FaWallet className="icon-box" />
                    </div>
                  </div>
                )}
              </>
            )}

            {auth.accessToken ? (
              <div className="d-flex align-items-center gap-2">
                <div
                  className="profile-info d-flex align-items-center gap-2"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/profile")}
                >
                  <img
                    src={profileImageSrc}
                    alt="Profile"
                    style={{ width: 32, height: 32, borderRadius: "50%", objectFit: "cover" }}
                    onError={(e) => {
                      e.currentTarget.src = Anonymath;
                    }}
                  />
                  <span className="profile-name" style={{ fontSize: "14px" }}>{nameUser?.split(" ")[0] || "المستخدم"}</span>
                </div>
                <Logout />
              </div>
            ) : (
              <div className="d-flex align-items-center gap-2 auth-buttons">
                <NavLink to="/login" className="btn-login">
                  تسجيل الدخول
                </NavLink>
                <NavLink to="/register" className="btn-rejster">
                  حساب جديد
                </NavLink>
              </div>
            )}
          </div>
        </Navbar.Collapse>

      </Layout>
    </Navbar>
    {showMessageCard && (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1050,
          backgroundColor: "rgba(0, 0, 0, 0.6)",
          backdropFilter: "blur(2px)",
        }}
        onClick={() => setShowMessageCard(false)}
      >
        <div onClick={(e) => e.stopPropagation()}>
          <HeaderWithMessage onClose={() => setShowMessageCard(false)} />
        </div>
      </div>
    )}
    </>
  );
}
